import { Component, OnInit } from '@angular/core';

import { Person } from '../app.component';
import { Spot } from '../app.component';
import { SpotAction } from '../app.component';
import { PersonService } from '../user/user.service';

import { UserComponent }   from '../user/user.component';
import { Router } from '@angular/router';

@Component({
    selector: 'table-cmp',
    moduleId: module.id,
    templateUrl: 'login.component.html',
    providers: [PersonService]
})

export class LoginComponent implements OnInit{
    public people: Person[];

    constructor(private personService: PersonService, private router: Router) { }

    ngOnInit(){
        if (parseInt(localStorage.getItem('selectedUser')) > 0) {
            this.router.navigate(['user']);
            return;
        }

        this.personService.getPeople().then(persons => {
            this.people = persons;
        });
    }

    loginUser(id: number) {
        localStorage.setItem('selectedUser', id.toString());
        this.router.navigate(['user']);
    }
}



// WEBPACK FOOTER //
// /Users/boriskolozsi/Documents/WWW/sps-web/src/app/login/login.component.ts